/* Cart3 product row carousels (sections/c3-product-row.liquid).
   Dawn's <slider-component> (global.js) sets `disabled` on the Next button once the last card is
   visible (and on Previous at the start), even while that button has keyboard focus. A disabled
   button cannot keep focus, so keyboard and screen-reader users were left on <body>. When the nav
   button that had focus becomes disabled, focus moves to the other nav button of the same row.
   Event delegation on document, so rows re-rendered by the theme editor keep working. */

(() => {
  if (window.c3ProductRowNav) return;
  window.c3ProductRowNav = true;

  // The row nav button that last received focus (cleared when focus moves anywhere else)
  let lastNavButton = null;
  let checkPending = false;

  document.addEventListener('focusin', (event) => {
    lastNavButton = event.target instanceof Element ? event.target.closest('.c3-row__button') : null;
  });

  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target;
      if (checkPending || !lastNavButton || !(track instanceof Element) || !track.classList.contains('c3-row__track')) {
        return;
      }

      // Capture phase runs before Dawn's own scroll listener on the track: check after it has updated the buttons
      checkPending = true;
      setTimeout(() => {
        checkPending = false;
        const button = lastNavButton;
        if (!button || !button.disabled) return;
        const slider = button.closest('slider-component');
        if (!slider || !slider.contains(track)) return;

        const active = document.activeElement;
        if (active && active !== button && active !== document.body) return;

        const otherName = button.name === 'next' ? 'previous' : 'next';
        const other = slider.querySelector(`.c3-row__button[name="${otherName}"]`);
        if (other && !other.disabled) other.focus();
      });
    },
    { capture: true, passive: true }
  );
})();
